import { sendErrorToDB } from "../../ConnectWS"

export function getStatsExTournament2(data) {
    try {

        let jsonData = data.flatMap(item => item.matches);
        let jsonDataMembers = data?.[0]?.members || [];
        // sprwadzamy jaki rodzaj statystyk
        let fiba = false
        if (jsonData[jsonData.length - 1]?.match_details_ex) {

            if (jsonData[jsonData.length - 1]?.match_details_ex.fiba === true) {
                fiba = true
            }
        }

        if (fiba) {
            return getMembersStatsAllFiba(jsonData, jsonDataMembers)
        } else {

            function getSortValue(key, value) {
                // zabezpieczenie ponieważ punkty i bramki musza być na koncu
                if (key === "points_scored") {
                    return 101
                } else if (key === "points_scored_goals") {
                    return 100
                }
                return value
            }

            let tmpM = []
            // tworzymy tablicę statsow
            let indexTab = 0

            if (jsonData[jsonData.length - 1]?.match_details_ex?.members) {
                indexTab = jsonData.length - 1
                for (const key in jsonData[indexTab].match_details_ex.members) {

                    if (key === 'matche_cards') {
                        //yellow: 0, yr: 0, red: 0
                        tmpM.push({ key: key, newkey: "matche_cards_yellow", sort: jsonData[indexTab].match_details_ex.members[key].sort + 0.1, value: 0, show_chart: jsonData[indexTab].match_details_ex.members[key].show_chart })
                        tmpM.push({ key: key, newkey: "matche_cards_yr", sort: jsonData[indexTab].match_details_ex.members[key].sort + 0.2, value: 0, show_chart: jsonData[indexTab].match_details_ex.members[key].show_chart })
                        tmpM.push({ key: key, newkey: "matche_cards_red", sort: jsonData[indexTab].match_details_ex.members[key].sort + 0.3, value: 0, show_chart: jsonData[indexTab].match_details_ex.members[key].show_chart })
                    } else {
                        if (jsonData[indexTab].match_details_ex.members[key].hide_viewers === true) {

                        } else {
                            tmpM.push({ key: key, newkey: key, sort: getSortValue(key, jsonData[indexTab].match_details_ex.members[key].sort), value: 0, show_chart: jsonData[indexTab].match_details_ex.members[key].show_chart })
                        }

                    }

                }

            }


            let tmpMT = []
            // lista membersów w drużynie

            jsonDataMembers.forEach(element => {
                if (element.members_list) {
                    element.members_list.forEach(element1 => {
                        tmpMT.push({

                            team_id: element.member_id, team_name: element.name, team_img: element.img_file, team_photo_file: element.team_photo_file,
                            member_id: element1.member_id, member_name: element1.member_name, member_img: element1.member_img_file,
                            member_team_id: element1.member_team_id,
                            stats: tmpM.sort((a, b) => a.sort - b.sort),
                        })
                    });
                }

            });



            if (tmpMT.length > 0 && jsonData && tmpM.length > 0) {
                // loop po zawodnikach
                let tmpMTtmp = JSON.parse(JSON.stringify(tmpMT));

                tmpMT.forEach((element, j) => {

                    // loop po stats
                    element.stats.forEach((elementStats, i) => {
                        //count_assist oraz konkretny members



                        jsonData.forEach(jsonDataElementMatches => {


                            if (jsonDataElementMatches.match_details_ex && jsonDataElementMatches.match_details_ex.members) {

                                if (jsonDataElementMatches.match_details_ex.members[elementStats.key] && jsonDataElementMatches.match_details_ex.members[elementStats.key].team1_id === element.team_id) {
                                    try {

                                        if (jsonDataElementMatches.match_details_ex.members[elementStats.key].team1_members[element.member_team_id] && jsonDataElementMatches.match_details_ex.members[elementStats.key].team1_members[element.member_team_id].value) {
                                            tmpMTtmp[j].stats[i].value = getValueData(jsonDataElementMatches.match_details_ex.members[elementStats.key].team1_members[element.member_team_id].value, elementStats.newkey, tmpMTtmp[j].stats[i].value)
                                        } else if (jsonDataElementMatches.match_details_ex.version === 2) {
                                            tmpMTtmp[j].stats[i].value = getValueDataVer2(element, jsonDataElementMatches.match_details_ex.members[elementStats.key], elementStats.newkey, tmpMTtmp[j].stats[i].value)

                                        }
                                    } catch (e) {
                                        if (Number(process.env.REACT_APP_API_DEBUG) === 1) {
                                            console.log(e)
                                        }
                                    }

                                } else if (jsonDataElementMatches.match_details_ex.members[elementStats.key] && jsonDataElementMatches.match_details_ex.members[elementStats.key].team2_id === element.team_id) {
                                    try {

                                        if (jsonDataElementMatches.match_details_ex.members[elementStats.key].team2_members[element.member_team_id] && jsonDataElementMatches.match_details_ex.members[elementStats.key].team2_members[element.member_team_id].value) {
                                            tmpMTtmp[j].stats[i].value = getValueData(jsonDataElementMatches.match_details_ex.members[elementStats.key].team2_members[element.member_team_id].value, elementStats.newkey, tmpMTtmp[j].stats[i].value)
                                        } else if (jsonDataElementMatches.match_details_ex.version === 2) {
                                            tmpMTtmp[j].stats[i].value = getValueDataVer2(element, jsonDataElementMatches.match_details_ex.members[elementStats.key], elementStats.newkey, tmpMTtmp[j].stats[i].value)

                                        }
                                    } catch (e) {
                                        if (Number(process.env.REACT_APP_API_DEBUG) === 1) {
                                            console.log(e)
                                        }
                                    }

                                }

                            }
                        })
                    })


                })



                // sortowanie po ostatniej statystyce
                return tmpMTtmp.sort((a, b) => b.stats[a.stats.length - 1].value - a.stats[a.stats.length - 1].value)
            }
            else {

                return []
            }
        }
    } catch (e) {
        console.log(e)
        return []
    }
}

function getMembersStatsAllFiba(jsonData, jsonDataMembers) {
    try {

        let tmpM = []
        // tworzymy tablicę statsow
        let indexTab = 0
        console.log("asdasd", jsonData)
        if (jsonData[jsonData.length - 1]?.stats_cfg) {
            indexTab = jsonData.length - 1
            for (const key in jsonData[indexTab].stats_cfg) {
                if (jsonData[indexTab].stats_cfg[key].showInMembers === true) {
                    tmpM.push({ key: key, newkey: key, sort: jsonData[indexTab].stats_cfg[key].sort, value: 0, showTop: jsonData[indexTab].stats_cfg[key].showTop, show_chart: jsonData[indexTab].stats_cfg[key].showChart })
                }
            }

        }



        let tmpMT = []
        // lista membersów w drużynie

        jsonDataMembers.forEach(element => {
            if (element.members_list) {
                element.members_list.forEach(element1 => {
                    tmpMT.push({
                        team_id: element.member_id, team_name: element.name, team_img: element.img_file, team_photo_file: element.team_photo_file,
                        member_id: element1.member_id, member_name: element1.member_name, member_img: element1.member_img_file,
                        member_team_id: element1.member_team_id,
                        stats: tmpM.sort((a, b) => a.sort - b.sort),
                    })
                });
            }

        });




        if (tmpMT.length > 0 && jsonData && tmpM.length > 0) {

            // loop po zawodnikach
            let tmpMTtmp = JSON.parse(JSON.stringify(tmpMT));

            tmpMT.forEach((element, j) => {

                // loop po stats
                element.stats.forEach((elementStats, i) => {
                    //count_assist oraz konkretny members

                    jsonData.forEach(jsonDataElementMatches => {

                        if (jsonDataElementMatches.match_details_ex && jsonDataElementMatches.match_details_ex.fiba && jsonDataElementMatches.match_details_ex.dataJson) {
                            if (jsonDataElementMatches.match_details_ex.dataJson.team1_id !== null && jsonDataElementMatches.match_details_ex.dataJson.team2_id !== null) {

                                if (jsonDataElementMatches.match_details_ex.dataJson.team1_id === element.team_id) {

                                    tmpMTtmp[j].stats[i].value = getValueDataFibo(tmpMTtmp[j].member_id, jsonDataElementMatches.match_details_ex.dataJson.team1_members, elementStats.newkey, tmpMTtmp[j].stats[i].value)
                                }

                                if (jsonDataElementMatches.match_details_ex.dataJson.team2_id === element.team_id) {

                                    tmpMTtmp[j].stats[i].value = getValueDataFibo(tmpMTtmp[j].member_id, jsonDataElementMatches.match_details_ex.dataJson.team2_members, elementStats.newkey, tmpMTtmp[j].stats[i].value)
                                }




                            }



                        }
                    })
                })


            })



            // sortowanie po ostatniej statystyce
            return tmpMTtmp.sort((a, b) => b.stats[a.stats.length - 1].value - a.stats[a.stats.length - 1].value)
        }
        else {
            return []
        }



    } catch (e) {
        sendErrorToDB(e, e, "FIBA STATS")
        return []
    }
}

export function uniqBy(a, key) {
    return [
        ...new Map(
            a.map(x => [key(x), x])
        ).values()
    ]
}

export function getValueDataFibo(member_id, rowMatch, jsontype, prevValue) {

    let valuetmp = null
    //valuetmp = rowMatch.find(item => { return item.member_id === member_id })
    let valuetmp1 = rowMatch.filter(item => item.member_id === member_id)
    if (valuetmp1.length === 0) {
        valuetmp = null
    } else if (valuetmp1.length === 1) {
        valuetmp = valuetmp1[0]
    } else {
        console.error("Znalezione takie same rekordy", valuetmp1)
        valuetmp = valuetmp1[0]
    }


    if (valuetmp != null && valuetmp[jsontype]) {

        let value = valuetmp[jsontype]
        // console.log("BODZIO",value,prevValue,jsontype)   
        if (value === null) {
            return 0 + prevValue
        } else if (jsontype === 'in_match' || jsontype === 'mvp') {
            if (value) {
                // true
                return 1 + prevValue
            } else {
                return 0 + prevValue
            }
        } else {
            return Number(value) + prevValue
        }
    }
    else {
        return Number(prevValue)
    }

}



export function getValueData(value, jsontype, prevValue) {

    if (value === null) {
        return 0 + prevValue
    } else if (jsontype === 'in_match' || jsontype === 'mvp') {
        if (value) {
            // true
            return 1 + prevValue
        } else {
            return 0 + prevValue
        }
    } else if (jsontype === "matche_cards_yellow") {
        if (value === "yellow") {
            return 1 + prevValue
        } else {
            return 0 + prevValue
        }
    } else if (jsontype === "matche_cards_yr") {
        if (value === "yellow-red") {
            return 1 + prevValue
        } else {
            return 0 + prevValue
        }
    } else if (jsontype === "matche_cards_red") {
        if (value === "red") {
            return 1 + prevValue
        } else {
            return 0 + prevValue
        }
    } else {
        return Number(value) + prevValue
    }

}

export function getValueDataVer2(members, rowMatch, jsontype, prevValue) {
    let value = null
    let valuetmp = null
    if (rowMatch.team1_id === members.team_id) {
        valuetmp = rowMatch.team1_members.find(item => { return item.member_id === members.member_id })
    } else if (rowMatch.team2_id === members.team_id) {
        valuetmp = rowMatch.team2_members.find(item => { return item.member_id === members.member_id })
    }

    if (valuetmp && valuetmp.member_id === members.member_id && valuetmp.value) {
        value = valuetmp.value
    }


    if (value === null) {
        return 0 + prevValue
    } else if (jsontype === 'in_match' || jsontype === 'mvp') {
        if (value) {
            // true
            return 1 + prevValue
        } else {
            return 0 + prevValue
        }
    } else if (jsontype === "matche_cards_yellow") {
        if (value === "yellow") {
            return 1 + prevValue
        } else {
            return 0 + prevValue
        }
    } else if (jsontype === "matche_cards_yr") {
        if (value === "yellow-red") {
            return 1 + prevValue
        } else {
            return 0 + prevValue
        }
    } else if (jsontype === "matche_cards_red") {
        if (value === "red") {
            return 1 + prevValue
        } else {
            return 0 + prevValue
        }
    } else {
        return Number(value) + prevValue
    }

}